/* global axios */
import ApiClient from './ApiClient';

class AiKnowledgeSourcesAPI extends ApiClient {
  constructor() {
    super('ai_knowledge_sources', { accountScoped: true });
  }

  create(data, file = null) {
    if (file) {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (value != null) formData.append(`knowledge_source[${key}]`, value);
      });
      formData.append('knowledge_source[file]', file);
      return axios.post(this.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }

    return axios.post(this.url, { knowledge_source: data });
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }
}

export default new AiKnowledgeSourcesAPI();
